import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Formik } from 'formik';
import * as yup from 'yup';
import { MFTextField, MFSubmitButton } from '../../lib/formik';
import { useDispatch } from 'react-redux';
import { loginWithOtp } from '../../redux-store/actions/auth';
import { useHistory } from 'react-router';
import { emailRegex, phoneRegExp } from '../../utils/regex';
import { LoginWithOtpResponseBody } from '../../redux-store/types/api-types';
import { CountryCodesDropDown, LoginLayout } from '../commonComponents';
import { getCountryCodes, preventSpecialCharacters } from '../../utils/utilityFunctions';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { RequiredFieldsMessage } from '../RequiredFieldsMessage';

interface Values {
  mobile: string;
  countryCode: string;
  countryNameAndCode: string;
  email: string;
}

const validationSchema = yup.object().shape({
  // mobile: yup
  //   .string()
  //   .required('Mobile number is required')
  //   .matches(phoneRegExp, 'Mobile number is not valid')
  //   .length(10, 'Mobile number should be maximum 10 digits'),
  // mobile: yup.string().test('mobile', (value, context) => {
  //   const { createError, path, parent } = context;
  //   const codesList = getCountryCodes()
  //     .map((codes) => {
  //       if (codes.label === parent.countryNameAndCode) {
  //         return codes.countryCode;
  //       }
  //     })
  //     .filter((ele) => ele)
  //     .toString();
  //   if (!value) {
  //     return createError({
  //       message: 'Mobile number is required',
  //       path,
  //     });
  //   }
  //   if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
  //     return createError({
  //       message: 'Invalid Mobile number',
  //       path,
  //     });
  //   }
  //   if (!isValidPhoneNumber(value, codesList as CountryCode)) {
  //     return createError({
  //       message: 'Invalid Mobile number',
  //       path,
  //     });
  //   }
  //   return true;
  // }),
  // countryNameAndCode: yup
  //   .string()
  //   .nullable()
  //   .test('countryNameAndCode', (value, context) => {
  //     const { createError, path, parent } = context;
  //     const codesList = getCountryCodes()
  //       .map((codes) => {
  //         if (codes.label === value) {
  //           return codes.countryCode;
  //         }
  //       })
  //       .filter((ele) => ele)
  //       .toString();
  //     if (!value) {
  //       return createError({
  //         message: 'Country Code is required',
  //         path,
  //       });
  //     }
  //     if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
  //       return createError({
  //         message: 'Invalid Mobile number',
  //         path,
  //       });
  //     }
  //     return true;
  //   }),
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid Email ID')
    .required('Email ID is required'),
});

export default function MobileLogin(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const onSubmit = async (values: Values) => {
    try {
      const { mobile = '', countryCode = '+91', countryNameAndCode = 'India: +91', email } = values;
      const res = (await dispatch(
        loginWithOtp({
          email: email,
        })
      )) as unknown as LoginWithOtpResponseBody;
      sessionStorage.setItem(
        'login_data',
        JSON.stringify({
          ...(res || {}),
          email,
          mobile,
          countryCode: countryNameAndCode?.split(':')[1].trim(),
        })
      );
      history.push('verify-otp', {
        mobile,
        countryCode: countryNameAndCode?.split(':')[1].trim(),
        emailDecrypted: email,
        ...(res || {}),
      });
    } catch (e) {
      console.error((e as unknown as Error).message);
    }
  };
  const initialValues: Values = {
    mobile: '',
    countryCode: '+91',
    countryNameAndCode: 'India: +91',
    email: '',
  };

  return (
    <LoginLayout LoginText="Login">
      <Formik onSubmit={onSubmit} initialValues={initialValues} validationSchema={validationSchema}>
        {({ handleSubmit, values, errors, touched }) => (
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{
              '.MuiLoadingButton-root': {
                mt: 5,
              },
              '.MuiInputLabel-root': {
                fontFamily: 'Poppins, sans-serif',
                fontSize: 16,
                fontWeight: 500,
              },
            }}>
            <div
              id="form-errors"
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              style={{
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: '0',
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                border: '0',
              }}>
              {touched.email && errors.email ? errors.email : ''}
            </div>
            <Grid item xs={12}>
              <RequiredFieldsMessage />
            </Grid>
            <MFTextField
              id="email"
              autoComplete="email"
              type="email"
              // autoFocus
              label="Email ID *"
              name="email"
              placeholder="Enter Email ID"
              required
            />
            {/* <MFTextField
              required
              label="Enter Mobile Number"
              name="mobile"
              type="text"
              placeholder="Enter Mobile Number"
              autoComplete="off"
              autoFocus
            /> */}
            <MFSubmitButton label="Get One-Time Password (OTP)" />
          </Box>
        )}
      </Formik>
    </LoginLayout>
  );
}
